import InnerComponent from '@Components/Admin/Vendors';
import orgContainer from '@Components/AppContainer';

const ViewOrgAdmin = () => ((orgContainer(InnerComponent)));
export default ViewOrgAdmin;
